import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'

import { AuthService } from '@app/core/service/auth.service'
import { Privilege } from '@app/core/model/enums/privilege.enum'

@Component({
  selector: 'name-editor',
  templateUrl: './name-editor.component.html',
  styleUrls: ['./name-editor.component.scss'],
})
export class NameEditorComponent implements OnChanges {
  @Input() name: string
  @Input() icon: string
  @Input() privilege: Privilege

  @Output() nameChanged = new EventEmitter<string>()

  isEditName: boolean
  modalForm: FormGroup = new FormGroup({ name: new FormControl('', [Validators.required]) })

  get nameControl() {
    return this.modalForm.get('name') as FormControl
  }

  get hasEditPrivilege() {
    return this.privilege ? this.authService.loggedInUser?.hasPrivilege(this.privilege) : true
  }

  constructor(private authService: AuthService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.name) this.modalForm.setValue({ name: this.name })
  }

  editName(name: string) {
    this.isEditName = true
    this.modalForm.setValue({ name })
  }

  submitName(currentName: string) {
    if (this.modalForm.valid) {
      if (currentName !== this.nameControl.value) this.nameChanged.emit(this.nameControl.value)
      this.isEditName = false
    }
  }
}
